import React, { useState } from 'react';
import { Button } from './Button';
import { Minimize2, ChevronDown, LucideIcon } from 'lucide-react';

export const CollapsiblePanel = ({ 
  title, 
  icon: Icon, 
  children, 
  defaultOpen = true, 
  className, 
  action,
  isOpen: controlledIsOpen,
  onToggle
}: { 
  title: string, 
  icon?: LucideIcon | React.ComponentType<{ className?: string }>, 
  children: React.ReactNode, 
  defaultOpen?: boolean, 
  className?: string, 
  action?: React.ReactNode,
  isOpen?: boolean,
  onToggle?: (isOpen: boolean) => void
}) => {
  const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen);
  
  const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;
  
  const toggle = () => {
    if (onToggle) {
      onToggle(!isOpen);
    } else {
      setInternalIsOpen(!isOpen);
    }
  };

  return (
    <div className={`glass-panel bg-black/40 text-white rounded-lg p-3 space-y-3 transition-all duration-300 ${className || ''}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase cursor-pointer flex-1" onClick={toggle}>
          {Icon && <Icon className="w-3 h-3" />} {title}
        </div>
        <div className="flex items-center gap-2">
            {action && <div onClick={(e) => e.stopPropagation()}>{action}</div>}
            <Button size="icon" variant="ghost" className="h-5 w-5 text-white" onClick={toggle}>
            {isOpen ? <Minimize2 className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
            </Button>
        </div>
      </div>
      {isOpen && <div className="animate-accordion-down overflow-hidden">{children}</div>}
    </div>
  );
};
